import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';

import { useSelector } from 'store';
import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM, LAYOUT_CONST } from 'config';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import shortNames from 'menu-items/shortNames';
// import NavButton from './NavButton';

// Add shortName property to menu items
const addShortNames = (items) => {
  if (!items) return items;

  return items.map((item) => {
    const newItem = { ...item };

    if (item.id && shortNames[item.id]) {
      newItem.shortName = shortNames[item.id];
    }

    if (item.children) {
      newItem.children = addShortNames(item.children);
    }

    return newItem;
  });
};

// Process menu items to add shortNames
const processedMenuItems = {
  ...menuItem,
  items: addShortNames(menuItem.items)
};

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);
  const [selectedItems, setSelectedItems] = useState('');
  const [selectedLevel, setSelectedLevel] = useState(0);

  const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = processedMenuItems.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < processedMenuItems.items.length) {
    lastItemId = processedMenuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = processedMenuItems.items.slice(lastItem - 1, processedMenuItems.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = processedMenuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
  return (
    <Stack direction="column" justifyContent="space-between" sx={{ minHeight: '100%' }}>
      <Box
        sx={{
          pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
          '& > ul:first-of-type': { mt: 0 },
          display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
        }}
      >
        {navGroups}
      </Box>
    </Stack>
  );
};

export default Navigation;
